import React from 'react';

import './styles/style.scss';

import { Lightbox } from '..';

const Avatar = ({ name, ...other }) => {

  return (
    <div className="avatar">
      <Lightbox
        style={{ cursor: 'pointer' }}
        className="mb-small"
        {...other}
      />
      {name && (
        <div className="avatar__tag">
          {name}
        </div>
      )}
    </div>
  )
}

export default Avatar;